export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
// export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';
export const BOOK_DETAILS = '/book-details';
export const YOUR_SHELF = '/your-shelf';
export const BOOKS_READ = '/your-shelf/books-read';

export const TO_READ_LIST = '/your-shelf/to-read';